import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "../../../environments/environment";

@Injectable({
	providedIn: "root",
})
export class CarInsuranceService {
	private basePath: string = `${environment.url}/api/TransferOwnership/`;
	private basePathPolicy: string = `${environment.url}/api/Policy/`;

	constructor(private http: HttpClient) {}

	uploadPhoto(id: string, file: any) {
		return this.http.post<{ id: string }>(
			`${this.basePathPolicy}UploadPhoto/${id}`,
			file,
		);
	}
}
